export function toTitleCase(str: string, splitchar:string = ' '): string {
    return str
      .toLowerCase()
      .split(splitchar)
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }